import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { i18n } from '../../../translate/i18n';
import * as actions from "../../../store/actions";
import {
  Typography, IconButton, TextField, FormControl, FormControlLabel, Switch
} from '@mui/material';
import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle
} from '../../Admin/Forms/styles';
import CloseIcon from '@mui/icons-material/Close';
import { map as asyncMap } from 'p-iteration';

const ModalBackup = (props) => {
  const { backup, closeModal } = props;
  const dispatch = useDispatch();
  const updateBackup = (id, body) => dispatch(actions.updateBackups(id, body))

  const [isIngested, setIsIngested] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    updateBackup(backup._id, { ...backup, ingested: isIngested });
  }

  const styles = {
    opacityContainer: {
      position: 'relative'
    },
    fileError: {
      color: '#f44336'
    },
		submittedContainer: {
			display: 'flex',
			color: 'grey',
			fontSize: '0.8rem',
			marginTop: '1rem'
		}
  }

  useEffect(() => {
    setIsIngested(backup.ingested);
  }, [backup])

  return (
    <FormStyled onSubmit={handleSubmit} style={styles.opacityContainer}>
      <DivFormTitle>
        <Typography variant='h6'>{i18n.t('modalBackups.title')}</Typography>
      </DivFormTitle>
      <FormControl variant="standard" fullWidth margin='normal' style={{marginBottom: 20}}>
        <TextField
          variant="standard"
          disabled={true}
          label={i18n.t('modalBackups.name')}
          name='name'
          value={backup.name} />
      </FormControl>
      <FormControl variant="standard" fullWidth margin='normal' style={{marginBottom: 20}}>
        <TextField
          variant="standard"
          disabled={true}
          label={i18n.t('modalBackups.fileType')}
          name='type'
          value={backup.fileType} />
      </FormControl>
      <FormControl variant="standard" fullWidth margin='normal' style={{marginBottom: 20}}>
        <TextField
          variant="standard"
          disabled={true}
          label={i18n.t('modalBackups.size')}
          name='size'
          value={backup.size} />
      </FormControl>
      <FormControl variant="standard" fullWidth margin='normal' style={{marginBottom: 20}}>
        <TextField
          variant="standard"
          disabled={true}
          label={i18n.t('modalBackups.size')}
          name='size'
          value={backup.size} />
      </FormControl>
      <FormControl variant="standard" fullWidth margin='normal' style={{marginBottom: 20}}>
        <TextField
          variant="standard"
          disabled={true}
          label={i18n.t('modalBackups.createdAt')}
          name='createdAt'
          value={backup.createdAt} />
      </FormControl>
      <FormControl variant="standard" fullWidth margin='normal' style={{marginBottom: 20}}>
        <TextField
          variant="standard"
          disabled={true}
          label={i18n.t('modalBackups.createdBy')}
          name='createdBy'
          value={backup.createdBy ? backup.createdBy.name : ''} />
      </FormControl>
      <FormControlLabel
        control={<Switch checked={isIngested} onChange={e => setIsIngested(e.target.checked)} />}
        label={i18n.t('modalBackups.ingested')}
      />
      <DivSubmitButtons>
        <IconButton onClick={() => closeModal(false)} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
        <IconButton disabled={isIngested === backup.ingested} type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
      </DivSubmitButtons>
    </FormStyled>
  );
}

export default ModalBackup;
